import { render, staticRenderFns } from "./PieChat.vue?vue&type=template&id=3fcdb84a&scoped=true"
import script from "./PieChat.vue?vue&type=script&lang=js"
export * from "./PieChat.vue?vue&type=script&lang=js"
import style0 from "./PieChat.vue?vue&type=style&index=0&id=3fcdb84a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fcdb84a",
  null
  
)

export default component.exports